import * as React from 'react';
import type { TenantSettingsService } from './TenantSettingsService';

export interface TenantSettingsContextValue {
  service: TenantSettingsService;
  tenantSlug: string;
  availableLocales?: string[];
  availableCurrencies?: string[];
}

const TenantSettingsContext = React.createContext<TenantSettingsContextValue | null>(null);

export interface TenantSettingsProviderProps {
  service: TenantSettingsService;
  tenantSlug: string;
  availableLocales?: string[];
  availableCurrencies?: string[];
  children: React.ReactNode;
}

export function TenantSettingsProvider({
  service,
  tenantSlug,
  availableLocales,
  availableCurrencies,
  children,
}: TenantSettingsProviderProps) {
  const value = React.useMemo(
    () => ({ service, tenantSlug, availableLocales, availableCurrencies }),
    [service, tenantSlug, availableLocales, availableCurrencies],
  );
  return <TenantSettingsContext.Provider value={value}>{children}</TenantSettingsContext.Provider>;
}

export function useTenantSettings(): TenantSettingsContextValue {
  const ctx = React.useContext(TenantSettingsContext);
  if (!ctx) throw new Error('useTenantSettings must be used inside <TenantSettingsProvider>');
  return ctx;
}
